module.exports = "/images/marker-student.png?b0c90121bd1cc60ea4c80ea66a97c850";